// Module that displays adonis errors in a UL in the form.
// TODO: It would probably be a good idea to either use a validation library for this,
// or to flesh it out more (e.g. put the error messages next to the fields).

import { getPageLang } from './utils';
import type { FormErrors } from 'App/Types/ApiData';

// TODO: Use this format across the app
export const displayErrorsObject = (
  form: HTMLFormElement,
  errors: FormErrors,
) => {
  const errorsWrapper = form.querySelector('.js-form-errors');
  if (!errorsWrapper) {
    console.error(errors);
    return;
  }

  // Clear previous errors
  errorsWrapper.innerHTML = '';

  // Create a UL to hold the errors
  const errorList = document.createElement('ul');
  errorList.classList.add('errors-list');
  errorsWrapper.appendChild(errorList);

  // Generate an LI for each error
  Object.keys(errors).forEach((key) => {
    const li = document.createElement('li');
    li.textContent = `${key}: ${errors[key]}`;
    errorList.appendChild(li);
  });
};

/** Display a generic error instead of errors from the backend. */
export const displayGenericError = (
  form: HTMLFormElement,
  error?: string,
) => {
  const errorsWrapper = form.querySelector('.js-form-errors');
  if (!errorsWrapper) {
    console.error(error);
    return;
  }

  const lang = getPageLang();
  // TODO: Move this to i18next when we have a good setup
  // and it's not wildly inefficient to just use a single string
  if (lang === 'fr') {
    error = '(FR) Error submitting form';
  } else {
    error = 'Error submitting form';
  }

  // Clear previous errors
  errorsWrapper.innerHTML = '';

  // Create a UL to hold the errors
  const errorList = document.createElement('ul');
  errorList.classList.add('errors-list');
  errorsWrapper.appendChild(errorList);

  // Generate an LI for each error
  const li = document.createElement('li');
  li.textContent = error;
  errorList.appendChild(li);
};
